import angular from 'angular';
import uiRouter from 'angular-ui-router';
import commonicdchangesComponent from './commonicdchanges.component';

let commonicdchangesModule = angular.module('commonicdchanges', [
  uiRouter
])

.component('commonicdchanges', commonicdchangesComponent);

export default commonicdchangesModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/commonicdchanges/commonicdchanges.js